import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ICON_NAMES, GasEmptyMessage, GasEmptyMessageIcon } from './gas-empty-message.interface';

@Component({
  selector: 'gas-empty-message',
  templateUrl: './gas-empty-message.component.html',
  styleUrls: ['./gas-empty-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasEmptyMessageComponent {
  /** тип контента, так же задает картинку */
  @Input()
  public type: GasEmptyMessage | string = 'default';

  /** заголовок для оповещения */
  @Input()
  public title: string;

  /** вспомогательный текст */
  @Input()
  public description: string;

  /** пользовательская иконка */
  @Input()
  public customIcon: GasEmptyMessageIcon;

  /** добавляет кнопку типа secondary */
  @Input()
  public secondaryButton: string;

  /** добавляет кнопку типа primary */
  @Input()
  public primaryButton: string;

  public iconNames = ICON_NAMES;
}
